import * as React from "react";
import { CheckIndeterminate, Plus } from "baseui/icon";
import { SHAPE, SIZE } from "baseui/button";
import { InputProps } from "baseui/input";

import { Block } from "../Block";
import { Input } from "../Input";
import { Button, KIND } from "../Button";
import { useNumberInput } from "./useNumberInput";
import { ButtonGroup } from "baseui/button-group";

type TNumberInputProps = {
  customInput?: React.ComponentType<InputProps>;
} & InputProps;

const NumberInput: React.FC<TNumberInputProps> = (props) => {
  const {
    showStepControls,
    decrementDisabled,
    incrementDisabled,
    decrement,
    increment,
    onInputChange,
    progress,
  } = useNumberInput(props);

  const {
    customInput: CustomInput = Input,
    type = "number",
    size,
    disabled,
    ...restProps
  } = props;

  return (
    <Block display="flex" alignItems="center">
      <Block marginRight="scale300" flex={1} position="relative">
        <CustomInput
          type={type}
          size={size}
          disabled={disabled}
          {...restProps}
          endEnhancer={restProps?.endEnhancer ? restProps?.endEnhancer : null}
          onChange={onInputChange}
        />
      </Block>
      {showStepControls && (
        <ButtonGroup
          kind={size === SIZE.mini ? KIND.tertiary : KIND.primary}
          size={size === SIZE.mini ? size : SIZE.compact}
          disabled={disabled}
          shape={SHAPE.circle}
        >
          <Button type="button" disabled={decrementDisabled} onClick={decrement}>
            <CheckIndeterminate title="Subtract" size="24px" />
          </Button>
          <Button type="button" disabled={incrementDisabled} onClick={increment}>
            <Plus title="Add" size="24px" />
          </Button>
        </ButtonGroup>
      )}
    </Block>
  );
};

export { NumberInput };
